import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { IUserData } from "../types";
import apiInstance from "../../api/instance";
import { authHeader } from "src/utils/authHeader";
import { BASE_PATH } from "src/config/constants";
import { getRootOrigin } from "src/utils/functions";

interface UserState {
  isLoggedIn: boolean;
  userData: IUserData | null;
}

interface LoginPayloadI {
  user_name: string;
  password: string;
  ip_address?: string;
}

const getInitialUserState = (): UserState => {
  const token = authHeader();
  const rawUserData = localStorage.getItem("user_data");
  let userData: IUserData | null = null;

  if (rawUserData) {
    try {
      userData = JSON.parse(rawUserData) as IUserData;
    } catch (error) {
      userData = null;
    }
  }

  return {
    isLoggedIn: Boolean(token && userData),
    userData,
  };
};

const initialState: UserState = getInitialUserState();

export const userLogin = createAsyncThunk(
  "user/userLogin",
  async (formData: LoginPayloadI, { rejectWithValue, getState }) => {
    try {
      const state: any = getState();
      const siteOrigin = state?.app?.artifacts?.base_url || getRootOrigin(window.location.origin);

      const response = await apiInstance.post("auth/admin-login", formData, {
        headers: {
          "x-site-origin": siteOrigin,
        },
      });
      const data = await response.data;
      if (data?.token) localStorage.setItem("token", data?.token);
      localStorage.setItem("user_data", JSON.stringify(data?.data));
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.status_message);
    }
  }
);

export const userLogout = createAsyncThunk("user/userLogout", async (_: undefined, { rejectWithValue }) => {
  await apiInstance
    .get("auth/logout")
    .then((data) => {
      window.location.replace(`${BASE_PATH}/login`);
      return data;
    })
    .catch((err) => rejectWithValue(err?.data));
});

const userReducer = createSlice({
  name: "user",
  initialState,
  reducers: {
    // login: (state, action) => {
    //   // console.log("login state", action.payload);
    // },
    logoutAction: (state) => {
      state.isLoggedIn = false;
      state.userData = null;
    },
    updateUserData: (state, action: PayloadAction<Partial<IUserData>>) => {
      if (!state.userData) return;
      state.userData = {
        ...state.userData,
        ...action.payload,
      };
    },
    setLogin: (state, action: PayloadAction<{ token: string; userData: IUserData }>) => {
      state.isLoggedIn = true;
      state.userData = action.payload.userData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.fulfilled, (state, { payload }) => {
        state.userData = payload.data;
        state.isLoggedIn = true;
      })
      .addCase(userLogin.pending, (state, { payload }) => {
        //
      })
      .addCase(userLogin.rejected, (state, { payload }) => {
        state = initialState;
      })
      .addCase(userLogout.fulfilled, (state) => {
        state.isLoggedIn = false;
        state.userData = null;
      })
      .addCase(userLogout.rejected, (state) => {
        state.isLoggedIn = false;
        state.userData = null;
      });
  },
});

export const { logoutAction, updateUserData, setLogin } = userReducer.actions;

export default userReducer.reducer;
